const styles = {
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40,
        overflow: 'hidden'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/type/TypeFull/TypeFull.css.js